import React, { useState, useEffect } from 'react';
import DirectoryService from './DirectoryService';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../common/functions/filterFieldsForList';
import schema from './user-details/birthdaysJsonSchema';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import useTableGenerator from '../common/functions/useTableGenerator';
import { useNavigate } from 'react-router-dom';
const UpcomingBirthdaysTable = () => {
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const [tableGenerated, setTableGenerated] = useState();
  const [refreshList, setRefreshList] = useState(false);
  const navigate = useNavigate();
  const convertTime = time => {
    const date = new Date(time);
    return date.toLocaleDateString();
  };
  const handleUserDetails = identifier => {
    console.log('User details for identifier:', identifier);
    navigate(`/app/wod/members/${identifier}`);
  };
  const jsonSchema = schema;
  const getNextBirthday = dob => {
    const [day, month] = dob.split('/').map(Number);

    const today = new Date();
    const birthday = new Date(today.getFullYear(), month - 1, day);

    // If this year's birthday has passed, use next year
    if (birthday < today) {
      birthday.setFullYear(today.getFullYear() + 1);
    }

    return birthday;
  };
  useEffect(() => {
    const fieldsForList = filterFieldsForList(jsonSchema);
    console.log('Fields for list', fieldsForList);
    setColumns(fieldsForList);

    DirectoryService.retrieveUpcomingBirthdays()
      .then(data => {
        const updatedData = data;

        const actionButtons = [
          {
            icon: 'edit',
            onClick: identifier => {
              handleUserDetails(identifier);
              setRefreshList(true);
            },
            className: 'p-0',
            title: 'Details',
            variant: 'action'
          }
        ];

        setNoDataToShow(updatedData.length === 0);
        setTableGenerated(
          useTableGenerator(updatedData, jsonSchema, actionButtons)
        );
        setRefreshList(false);
      })
      .catch(error => setError(error.message));
  }, [refreshList]);

  const buttonsConf = [];
  const headerGenerated = useHeaderGenerator(
    'Upcoming Birthdays',
    ' ',
    buttonsConf
  );

  return (
    <>
      {error}
      {headerGenerated}
      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any UpcomingBirthdays to show.
        </Alert>
      )}
      {tableGenerated}
    </>
  );
};

export default UpcomingBirthdaysTable;
